/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MainWindowSetting.vue?vue&type=template&id=ef4a678e&scoped=true&"
import script from "./MainWindowSetting.vue?vue&type=script&lang=js&"
export * from "./MainWindowSetting.vue?vue&type=script&lang=js&"
import style0 from "./MainWindowSetting.vue?vue&type=style&index=0&id=ef4a678e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4a678e",
  null
  
)

export default component.exports